import React from "react";
import styles from './Modal.module.scss';
import PropTypes from "prop-types";

const Modal = ({
  children,
  scrollable = true,
  overflowVisible = false
}) => {
  return (
    <div className={`${styles.overlay} ${scrollable ? styles.scrollable : ''} ${overflowVisible ? styles.overflowVisible : ''}`}>
      <div className={styles.modal}>
        {children}
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  scrollable: PropTypes.bool,
  overflowVisible: PropTypes.bool,
}

export default Modal;